import './ownButton.scss';

import React, { FunctionComponent } from 'react';

import CodeBlock from '../CodeBlock/CodeBlock';
import { HelpLink } from './HelpLink';
import config from '../../config';
import { useCharityData } from '../../context/charityContext';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { useTranslation } from 'react-i18next';

type Props = {
  isDefault?: boolean;
  linkId?: string;
};

const OwnButton: FunctionComponent<Props> = ({ isDefault = false, linkId }) => {
  const copyToClipboard = useCopyToClipboard();
  const { t } = useTranslation();
  const { charity, charityId } = useCharityData();

  const linkIdOrCharityId = () => {
    if (isDefault) return `data-charityId="${charityId}"`;
    return `data-linkId="${linkId}"`;
  };

  return (
    <>
      <p>{t('donateButton.ownButton.instruction1')}</p>
      <CodeBlock id="instruction1" ariaLabel="HTML button example">
        <span className="exampleCode">{`<button class="example-button">Donate now</button>`}</span>
      </CodeBlock>
      <p className="jg-space-mtmd">
        {t('donateButton.ownButton.instruction2')}
      </p>
      <CodeBlock
        ariaLabel="required HTML attributes"
        id="instruction2"
        dataQa="button-example"
      >
        <span className="exampleCode">{'<button data-jg-donate-button '}</span>
        {`${linkIdOrCharityId()} data-marketCode="${
          charity?.operatingCompanyCode ?? 'GB'
        }" data-linkType="givingCheckout">`}
        <span className="exampleCode">{'Donate now</button>'}</span>
      </CodeBlock>
      <p className="jg-space-mtmd">
        {t('donateButton.ownButton.instruction3')}
      </p>
      <CodeBlock id="own-button-code" ariaLabel="" dataQa="widget-code">
        {`<script src="${config.WIDGET_URL}" data-version="${config.WIDGET_VERSION}" data-widgetType="attachCheckout" type="text/javascript"></script>`}
      </CodeBlock>
      <p className="note">{t('donateButton.ownButton.note')}</p>
      <button
        id="add-own-button--copy"
        className="jg-btn jg-btn--secondary gc-button-width jg-space-mtmd"
        onClick={() =>
          copyToClipboard('add-own-button--copy', 'own-button-code')
        }
      >
        {t('common.copy')}
      </button>
      <HelpLink />
    </>
  );
};

export default OwnButton;
